module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/waiting/choose-container-lRdxFMGM.html";